module.exports = __webpack_public_path__ + "media/images/thumbs/anatomyphysiology/av256-3eec9e7029d70244a7869ccb04e72439.jpg";